export function debounce(callback, timeoutMs = 500) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            callback.apply(this, args);
        }, timeoutMs);
    };
}
//# sourceMappingURL=debounce.js.map